// `?stars=N` from the receipt mail's five star links (spec 2026-10-15 §3.1).
// Only the exact strings '1'..'5' count; anything else is ignored.
export const parseStars = (raw) => {
  if (typeof raw !== 'string' || !/^[1-5]$/.test(raw)) return undefined;
  return Number(raw);
};
